import { useMemo } from 'react';

import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';

import { useCmsApiPageSubsite } from './useCmsApiPageSubsite';

type Props = {
  cmsApiPage: CmsApiPage | undefined;
};

export function useCmsApiPageDefaultSearchType({
  cmsApiPage,
}: Props): DefaultSearchType {
  const subsite = useCmsApiPageSubsite({ cmsApiPage });

  const heroSearch = cmsApiPage && cmsApiPage.heroSearch;

  return useMemo(() => {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (heroSearch && heroSearch.defaultSearchFilters) {
      return heroSearch.defaultSearchFilters.type;
    }

    if (subsite) return subsite.defaultSearchType;

    return 'JOB';
  }, [heroSearch, subsite]);
}
